import { defineComponent as s, resolveComponent as r, openBlock as p, createElementBlock as c, createVNode as a, pushScopeId as u, popScopeId as S, createElementVNode as h } from "vue";
import k from "../VFormDatepicker/VFormDatepicker.js";
import f from "../VFormTimeslotPicker/VFormTimeslotPicker.js";
import { _ as g } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../VFormField/VFormField.js";
import "../../../vee-validate.esm-c4518011.js";
import "../../../utils/htmlSanitizer.js";
import "../../atoms/VIcon/VIcon.js";
import "../../atoms/VIconButton/VIconButton.js";
import "../../atoms/VText/VText.js";
import "../../../utils/tailwindUnitsConverter.js";
import "../../../constants-69d32a0e.js";
import "../VFormRadioCheckbox/VFormRadioCheckbox.js";
import "../../atoms/VFormRadioCheckboxGroup/VFormRadioCheckboxGroup.js";
import "../../../composables/useSpacingClass.js";
import "../../../VHeadline.vue_vue_type_script_lang-186a5340.js";
import "../../../composables/useShowPriceDisclaimer.js";
import "../../../VState-9b477ed6.js";
import "../../atoms/VButton/VButton.js";
import "../../atoms/VSpinner/VSpinner.js";
import "../../atoms/VHTMLText/VHTMLText.js";
import "../../atoms/VLink/VLink.js";
import "../../../utils/isExternalUrl.js";
import "../../atoms/VSubtitle/VSubtitle.js";
import "../../../Spacing-695d3b19.js";
import "../../../VImage-b57fd9d1.js";
const n = "dateAndTimeSlotPicker:date-selected", l = "dateAndTimeSlotPicker:timeslot-selected", T = s({
  name: "VFormDateAndTimeSlotPicker",
  components: { VFormDatepicker: k, VFormTimeslotPicker: f },
  emits: [
    n,
    l
  ],
  inheritAttrs: !1,
  props: {
    datepickerName: {
      type: String,
      required: !0
    },
    datepickerId: {
      type: String,
      required: !0
    },
    datesWithSlots: {
      type: Array,
      default: () => []
    },
    timeSlotPickerName: {
      type: String,
      required: !0
    },
    timeslotPickerLabel: {
      type: String,
      default: "Zeit wählen"
    },
    datePickerLabel: {
      type: String,
      default: "Datum wählen"
    },
    noTimeSlotTitle: { type: String, default: "Kein Termin verfügbar" },
    noTimeSlotDescription: {
      type: String,
      default: "Es sind leider keine Termine verfügbar. Bitte wähle einen anderen Tag aus."
    },
    timeslotValue: {
      type: String,
      default: ""
    },
    validationRules: {
      type: Function,
      default: () => !0
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  },
  data() {
    return { dateValue: this.timeslotValue };
  },
  computed: {
    selectedDateWithSlot() {
      const e = new Date(this.dateValue);
      return isNaN(+e) ? void 0 : this.datesWithSlots.find((o) => {
        const i = new Date(o.iso);
        return e.toLocaleDateString() === i.toLocaleDateString();
      });
    },
    datePickerConfig() {
      return { enable: this.datesWithSlots.map(
        (t) => t.iso
      ) };
    }
  },
  methods: {
    onDatepickerChange(e) {
      this.dateValue = e.length ? e[0].toISOString() : "", this.$emit(n, e);
    }
  },
  setup(e, t) {
    return {
      onChange: (i) => {
        t.emit(l, i);
      }
    };
  }
});
const D = (e) => (u("data-v-55d17bb9"), e = e(), S(), e), v = { class: "hobi-date-and-time-slot-picker" }, P = /* @__PURE__ */ D(() => /* @__PURE__ */ h("div", { id: "hobi-time-slot-picker" }, null, -1));
function V(e, t, o, i, b, y) {
  const m = r("VFormDatepicker"), d = r("VFormTimeslotPicker");
  return p(), c("div", v, [
    a(m, {
      value: e.dateValue,
      id: e.datepickerId,
      fieldName: e.datepickerName,
      "onDatePicker:change": e.onDatepickerChange,
      config: e.datePickerConfig,
      "validation-rules": e.validationRules
    }, null, 8, ["value", "id", "fieldName", "onDatePicker:change", "config", "validation-rules"]),
    P,
    a(d, {
      name: e.timeSlotPickerName,
      dateWithSlots: e.selectedDateWithSlot,
      label: e.timeslotPickerLabel,
      noTimeSlotTitle: e.noTimeSlotTitle,
      noTimeSlotDescription: e.noTimeSlotDescription,
      timeslotValue: e.timeslotValue,
      "onTimeSlotPicker:change": e.onChange,
      "validation-rules": e.validationRules,
      router: e.router
    }, null, 8, ["name", "dateWithSlots", "label", "noTimeSlotTitle", "noTimeSlotDescription", "timeslotValue", "onTimeSlotPicker:change", "validation-rules", "router"])
  ]);
}
const Y = /* @__PURE__ */ g(T, [["render", V], ["__scopeId", "data-v-55d17bb9"]]);
export {
  Y as default
};
